import { placeholdersMap } from "@monorepo/components";
import { IResponseError, IServiceParameter } from "@monorepo/types";
import { SerializedError } from "@reduxjs/toolkit";

export const findErrorByParam = ({
  error,
  param,
}: {
  error?: Array<IResponseError> | SerializedError | null;
  param: string;
}): string | undefined => {
  if (!error) {
    return undefined;
  }
  if (Array.isArray(error)) {
    return error.find((err) => err?.source?.parameter === param)?.title || undefined;
  }
  return undefined;
};

export const findErrorDetailByParam = ({
  error,
  param,
}: {
  error?: Array<IResponseError> | SerializedError | null;
  param: string;
}): string | undefined => {
  if (!error) {
    return undefined;
  }
  if (Array.isArray(error)) {
    return error.find((err) => err?.source?.parameter === param)?.detail || undefined;
  }
  return undefined;
};

export const getNonParameterisedErrors = (
  error: Array<IResponseError> | SerializedError | undefined
): Array<IResponseError> | undefined => {
  if (Array.isArray(error) && error?.length) {
    return error.filter((err) => !err?.source?.parameter);
  }
  return undefined;
};

export const getParameterisedErrors = (error: Array<IResponseError> | SerializedError | undefined) => {
  if (Array.isArray(error) && error?.length) {
    return error.filter((err) => err?.source?.parameter);
  }
  return undefined;
};

export const mapDefaultValues = (
  parameters: Array<IServiceParameter> | undefined = [],
  values: Record<string, any> = {}
) => {
  const mappedParameters = parameters.reduce(
    (acc, item) => ({
      [item.parameter_name]: String(item.value) || placeholdersMap[item.parameter_type as keyof typeof placeholdersMap],
      ...acc,
    }),
    {} as any
  );

  const mappedValues = Object.entries(values).reduce(
    (acc, [key, value]) => ({
      [key]: String(value),
      ...acc,
    }),
    {}
  );

  return {
    ...mappedParameters,
    ...mappedValues,
  };
};
